import * as dateUtil from '../util/DateUtil'
export default class MachineViewModel {
    constructor(data) {
        // 筐体id
        this.id = data.id;
        // 筐体名
        this.name = data.name;
        // 筐体識別子
        this.seriesId = data.seriesId;
        // バージョン
        this.version = data.version;
        // 筐体発売日
        this.machineLaunchAt = data.machineLaunchAt;
        // ピクトリンク導線追加日 (nullの場合は過去の日を設定)
        this.pictlinkLaunchAt = data.pictlinkLaunchAt ? data.pictlinkLaunchAt : "2020-01-01T00:00:00+09:00";
        // 筐体通信終了日 (nullの場合は100年後などを設定)
        this.endAt = data.endAt ? data.endAt : "2120-01-16T00:00:00+09:00";
        // 筐体テキスト
        this.description = data.description;
        // 証明プリ搭載かどうか
        this.isStudio = data.isStudio;
        // ID連携対応かどうか
        this.appLinkageSupported = data.isIdFederationSupported;
    }

    // moment型に変換
    get machineLaunchAtMoment() {
        return dateUtil.getMoment(this.machineLaunchAt);
    }
    get endAtMoment() {
        return dateUtil.getMoment(this.endAt);
    }
}
